import React from "react";
import ptBr from "../../../config/texts/pt-br";
import { Grid } from "@material-ui/core";
import Styles from "../styles/Styles";
import { masks } from "../../../utils";
import { fonts } from "../../../config";
import { CustomText } from "../../../components";

function ModalView({ item }) {
    const texts = ptBr.login;

    return (
        <>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "clamp(250px, 26vw, 500px)",
                    paddingInline: "25px",
                    marginBottom: "20px",
                }}
            >
                <CustomText
                    style={{ marginBottom: "20px" }}
                    fontFamily={fonts.bold}
                    fontSize={14 / 8}
                    textColor="#B2B2B2"
                >
                    DADOS DA PRESTADORA DE SERVIÇO:
                </CustomText>
                <Grid alignItems="flex-end" container spacing={1}>
                    <Grid item xs={12} md={6} lg={6}>
                        <Styles.InfoName>NOME DA EMPRESA</Styles.InfoName>
                        <Styles.InfoValueData>{item?.name}</Styles.InfoValueData>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <Styles.InfoName>CNPJ</Styles.InfoName>
                        <Styles.InfoValueData>
                            {masks.CNPJ(item?.cnpj)}
                        </Styles.InfoValueData>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <Styles.InfoName>NOME DO RESPONSÁVEL</Styles.InfoName>
                        <Styles.InfoValueData>{item?.responsibleName}</Styles.InfoValueData>
                    </Grid>{" "}
                    <Grid item xs={12} md={6} lg={6}>
                        <Styles.InfoName>TELEFONE</Styles.InfoName>
                        <Styles.InfoValueData>{masks.inputMaskTELWithDDD(item?.phone)}</Styles.InfoValueData>
                    </Grid>{" "}
                    <Grid item xs={12} md={6} lg={12}>
                        <Styles.InfoName>E-MAIL RESPONSÁVEL</Styles.InfoName>
                        <Styles.InfoValueData>{item?.email}</Styles.InfoValueData>
                    </Grid>
                </Grid>

                <Styles.customLine />

                <CustomText fontSize={2} textColor="#B2B2B2" fontFamily={fonts.bold}>
                    RESPONSÁVEL PELO CADASTRO:
                </CustomText>

                <Grid alignItems="flex-end" container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Styles.InfoName>NOME COMPLETO</Styles.InfoName>
                        <Styles.InfoValueData>{item?.createdBy.name}</Styles.InfoValueData>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <Styles.InfoName>E-MAIL</Styles.InfoName>
                        <Styles.InfoValueData>{item?.createdBy.email}</Styles.InfoValueData>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                        <Styles.InfoName>DATA DO CADASTRO</Styles.InfoName>
                        <Styles.InfoValueData>{masks?.formatDate(item?.createdBy.createdAt)}</Styles.InfoValueData>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                        <Styles.InfoName>TIPO DE PERFIL</Styles.InfoName>
                        <Styles.InfoValueData>{item?.createdBy.role.replace("admin_bewiki","SuperAdmin").replace("admin","Proprietário").replace("manager","Gestor")}</Styles.InfoValueData>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ModalView;
